<template>
  <div class="main">
    <headpage title="查看学费"></headpage>
    <div class="banner">
      <van-image src="https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/contact/os.jpg">
        <template v-slot:loading>
          <van-loading size="20" color="#fff" />
        </template>
      </van-image>
    </div>
    <div class="gif">
      <div class="git-one" v-for="gif in gifs" :key="gif.id">
        <div class="gif-gif">
          <img :src="gif.url" alt />
        </div>
        <div class="gif-name">{{ gif.name }}</div>
      </div>
    </div>
    <van-divider dashed :style="{ color: '#27272a', borderColor: '#27272a', padding: '0 10px' }">
      <b>凭真实手机号获取</b>
    </van-divider>
  <newform titlecolor="#ff0000" bag="#ff0000" bordercolor="#ff0000"></newform>
    <van-divider dashed :style="{ color: '#27272a', borderColor: '#27272a', padding: '0 16px' }">
      <b>凭真实手机号获取</b>
    </van-divider>

    <div class="h20px" style="width:100%;height:20px"></div>
    <foot></foot>
  </div>
</template>

<script>
import { Notify } from "vant";
import { Toast } from "vant";
export default {
  data() {
    return {
      username1: "",
      mobile1: "",
      loading: false,
      buttonWords1: "提交获取学费",
      // radio1: "西点",
      gifs: [
        {
          name: "西点",
          url:
            "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/contact/xidian.gif"
        },
        {
          name: "西餐",
          url:
            "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/contact/xican.gif"
        },
        {
          name: "咖啡",
          url:
            "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/contact/coffee.gif"
        },
        {
          name: "调酒",
          url:
            "https://cdomick.oss-cn-shenzhen.aliyuncs.com/newwap/img/contact/tiaojiu.gif"
        }
      ]
    };
  },
  components: {
    headpage: () => import("../../components/head/headpage"),
    foot: () => import("@/components/foot/foot"),
    newform: () => import("@/components/form/newform")
  },
  methods: {
    send() {
      this.buttonWords1 = "";
      this.loading = true;
      let valid_rule = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
      console.log(this.$route.path);
      setTimeout(() => {
        this.loading = false;
        this.buttonWords1 = "提交获取学费";
      }, 1500);
      if (this.username1 == "" || this.mobile1 == "") {
        Toast.fail("请完整填写表单");
        return false;
      } else if (!valid_rule.test(this.mobile1)) {
        Toast.fail("手机号码错误");
        return false;
      } else {
        this.$axios
          // .get("http://api.cdomick.com/index.php/api/form", {
          .get("http://api.cdomick.com/index.php/form/insert", {
            params: {
              name: this.username1,
              mobile: this.mobile1,
              // c_like: this.radio1,
              laiyuan: document.referrer,
              first: this.$route.path
            }
          })
          .then(function(response) {
            console.log(response);
            if (response.data.code == 1) {
              Toast.success(response.data.msg);
            } else {
              Toast.success("提交成功");
            }
          })
          .catch(function(error) {
            console.log(error);
            Toast.success("成功");
            this.loading = false;
            this.buttonWords1 = "提交获取学费";
          });
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-cell {
  border: 2px solid #9e9e9e;
  margin-bottom: 10px;
}
.banner {
  width: 100%;
  height: 256px;
  margin-top: 50px;
  position: relative;
}
.banner img {
  width: 100%;
  height: 100%;
}
h1 {
  position: absolute;
  top: 25px;
  left: 33%;
  color: #fff;
}
h3 {
  margin: 0 auto 0 auto;
  text-align: center;
  color: #020202;
}
h4 {
  position: absolute;
  left: 19%;
  bottom: 40px;
  color: #fff;
}
.gif {
  width: 100%;
  margin-top: 5px;
  height: 90px;
}
.git-one {
  width: 25%;
  height: 100px;
  float: left;
}
.gif-gif {
  width: 60px;
  height: 60px;
  margin-left: auto;
  margin-right: auto;
}
.gif-gif img {
  width: 100%;
  height: 100%;
}
.gif-name {
  width: 100%;
  height: 20px;
  text-align: center;
}
.an-field {
  background: #eee;
}
.form {
  text-align: center;
  padding: 16px;
}
.form input {
  margin-bottom: 10px;
}
.checkbox {
  float: left;
  margin-right: 7px;
}
.form button {
  color: #fff;
  width: 92%;
  margin-top: 27px;
  line-height: 40px;
  height: 40px;
  background: #ff0000;
  // background-image: linear-gradient(
  //   to right,
  //   rgb(249, 213, 227) 0%,
  //   rgb(206, 233, 254) 100%
  // );
  border: none;
}
</style>
